import React from "react";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import HelpCenterComponent from "../../../components/HelpCenter/HelpCenter";
import Notification from "../../../components/Notification/Notification";
import AdminNotification from "../../../components/Notification/AdminNotification";
import InstructorNotification from "../../../components/Notification/InstructorNotification";
import { useSelector } from "react-redux";

const HelpCenter = () => {
  const auth = useSelector((state) => state.auth);
  return (
    <>
      {/* Topbar */}
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="ah-heading-04 fw-bold black-800 me-29 mb-0 d-flex align-items-center gap-3">
            Help Center
          </h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            {auth.role === "Admin" ? (
              <AdminNotification />
            ) : auth.role === "Instructor" ? (
              <InstructorNotification />
            ) : auth.role === "Student" ? (
              <Notification />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <HelpCenterComponent />
    </>
  );
};

export default HelpCenter;
